import React from 'react';
import { bool, func, node } from 'prop-types';
import styled, { css } from 'styled-components';
import { Flex, Icon, Typography } from '@atoms';
import { ReactComponent as Arrow } from '@assets/drawer-arrow.svg';

const Drawer = ({
  isDrawerOpened,
  onDrawerOpen,
  children,
}) => {
  const drawerHeaderText = isDrawerOpened
    ? 'SELECT OPTIONS OR TAP HERE TO CLOSE'
    : 'TAP TO EXPAND AND SELECT YOUR OPTIONS';

  return (
    <Wrapper
      grow={0}
      column
      isDrawerOpened={isDrawerOpened}
    >
      {!isDrawerOpened && <TriggerOverlay onClick={onDrawerOpen} />}
      <Trigger
        grow={0}
        shrink={0}
        column
        isDrawerOpened={isDrawerOpened}
        onClick={onDrawerOpen}
      >
        <Flex justifyCenter padding="md">
          <Typography color="white" size="sm" weight="black">
            {drawerHeaderText}
          </Typography>
        </Flex>
        <ArrowWrapper justifyCenter padding="xxs">
          <Icon SVG={Arrow} width="10px" height="4.2px" />
        </ArrowWrapper>
      </Trigger>
      <Content isDrawerOpened={isDrawerOpened} column>
        {children}
      </Content>
    </Wrapper>
  );
};

const Wrapper = styled(Flex)`
  ${({ isDrawerOpened }) => css`
    height: ${isDrawerOpened ? '100%' : '35%'};
    transition: height 0.2s ease-out;
    overflow: hidden;
    position: relative;
  `}
`;

const ArrowWrapper = styled(Flex)`
  ${({ theme: { color } }) => css`
    background: ${color.dust}; // TODO: grey color on design is #d9d9d9

    svg {
      transform: rotate(180deg);
    }
  `}
`;

const TriggerOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
`;

const Content = styled(Flex)`
  background-color: rgba(255, 255, 255, 0.9);
  height: 100%;
  overflow: hidden;
`;

const Trigger = styled(Flex)`
  ${({ isDrawerOpened, theme: { color } }) => css`
    ${Flex}:first-of-type {
      background: ${color.strawberry};
    }

    ${isDrawerOpened && `
      ${Flex}:first-of-type {
        background: ${color.grannySmith};
      }

      ${ArrowWrapper} {
        svg {
          transform: rotate(360deg);
        }
      }
    `}
  `}
`;

Drawer.propTypes = {
  isDrawerOpened: bool.isRequired,
  onDrawerOpen: func.isRequired,
  children: node.isRequired,
};

export default Drawer;
